import {useQuery} from '@tanstack/react-query'
import {usePolling} from '../../hooks/use-polling.js'
import {getCurrentMetrics} from '../../api/metrics.js'
import {listActiveScenarios} from '../../api/scenarios.js'
import {listNotifications} from '../../api/notifications.js'

export function useDashboardData() {
    const metrics = usePolling({
        queryKey: ['metrics', 'current'],
        queryFn: getCurrentMetrics,
        intervalMs: 10_000,
        staleTime: 5_000
    })
    const active = usePolling({
        queryKey: ['scenarios', 'active'],
        queryFn: listActiveScenarios,
        intervalMs: 2_000,
        staleTime: 0
    })
    const notifications = useQuery({
        queryKey: ['notifications', 'unread'],
        queryFn: () => listNotifications({unread: true}),
        refetchInterval: 30_000,
        staleTime: 30_000
    })
    return {metrics, active, notifications}
}
